import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { aux, colors, darkThemeName } from "theme";
import logoBlack from "assets/logo_black.svg";
import logoWhite from "assets/logo_white.svg";
import BellIcon from "components/common/Svg/Bell";
import { NOTIFICATIONS } from "routes/pageConfig";
import { hasPagePermission } from "routes/utils";
import { ThemeContext } from "components/common";
import Boop from "../common/Boop";
import HeaderDropdown from "./HeaderDropdown";

const HeaderMobile = () => {
  const { push } = useHistory();
  const { theme } = useContext(ThemeContext);

  return (
    <div className="flex-col">
      <div
        className={ `flex w-full ${theme === darkThemeName ? "bg-black" : "bg-white"}` }
        style={{ height: aux.headerHeight }}
      >
        <div className="flex justify-between items-center w-full pr-4 pl-4">
          <div className="flex-1">
            <button
              className="outline-0-important"
              type="button"
              onClick={() => {
                push("/");
              }}
            >
              <img alt="logo" src={theme === darkThemeName ? logoWhite : logoBlack} style={{ height: "29px" }} />
            </button>
          </div>
          <nav id="navigation">
            <ul className="links mr-5 md:mr-6">
              {hasPagePermission(NOTIFICATIONS) && (
                <li>
                  <button
                    type="button"
                    onClick={() => {
                      push("/notifications");
                    }}
                    className="ml-12 mx-5 outline-0-important"
                  >
                    <Boop rotation={20} timing={200}>
                      <BellIcon color={theme === darkThemeName ? colors.white : colors["black-primary"]} style={{ width: "29px" }} />
                    </Boop>
                  </button>
                </li>
              )}
              <HeaderDropdown className="mr-3" iconColor={theme === darkThemeName ? "white" : "black"} />
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default HeaderMobile;
